import { render, staticRenderFns } from "./number.component.vue?vue&type=template&id=3f5680e2"
import script from "./number.component.vue?vue&type=script&lang=ts"
export * from "./number.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports